import React, { FC } from 'react';
import classNames from 'classnames';

import useCarsApi from 'providers/cars-api/use-cars-api';
import Steps from './steps';
import CountrySelect from './country-select';
import LanguageSelect from './language-select';

import styles from './header.module.scss';

type Props = {
  pageName?: string;
};

const PageHeader: FC<Props> = ({ pageName = '' }) => {
  const { subpage } = useCarsApi();

  return (
    <header
      className={classNames(styles.header, 'header__page-header', {
        [styles['header--enlarged']]: subpage === 'searchform',
        [styles['header--booking']]: subpage === 'bookingForm'
      })}
    >
      {pageName && <h1 className="sr-only pageTitle">{pageName}</h1>}

      {(subpage === 'offerlist' || subpage === 'searchform') && (
        <div className={classNames(styles.header__bar, 'header_header__bar')}>
          <CountrySelect />
          <LanguageSelect />
        </div>
      )}

      <Steps />
    </header>
  );
};
export default PageHeader;
